import { render } from "./LoginMethodIcon.vue?vue&type=template&id=7defd273&scoped=true"
import script from "./LoginMethodIcon.vue?vue&type=script&lang=js"
export * from "./LoginMethodIcon.vue?vue&type=script&lang=js"

import "./LoginMethodIcon.vue?vue&type=style&index=0&id=7defd273&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7defd273"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QImg});
